export const chickenAndFriedTenem = {
  id: "chickenAndFriedTenem",
  link: "/#/recipes/recipes/chickenAndFriedTenem",
  name: "Chicken and Fried Tenem",
  cuisine: "Alethi Men's Food",
  summary: "Deep fried butternut squash with chicken medallions and pan sauce",
  inspiration: null,
  quantity: "4 servings",
  time: "30 minutes",
  notes:
    "My original idea was to serve deep fried sweet potato with peppery chicken, since I love deep fried sweet potatoes, but as I researched more I realized tenem couldn't be sweet potatoes. Instead I opted for butternut squash, and it worked well. The sauce came about as an attempt to bring a little more moisture and cohesion to the dish.",
  quotes:
    "It was steaming peppered chicken, cut in medallions and laid atop fried round slices of tenem, a soft, light orange vegetable. (The Way of Kings ch 22)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/chicken-tenem-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "chicken",
          display: "2 chicken breasts"
        },
        {
          item: "dairy",
          display: "4 tbsp butter, divided"
        },
        {
          item: "salt",
          display: "1/2 tsp salt"
        },
        {
          item: "turmeric",
          display: "1/2 tsp ground turmeric"
        },
        {
          item: "cumin",
          display: "1/2 tsp ground cumin"
        },
        {
          item: "coriander",
          display: "1/2 tsp ground coriander"
        },
        {
          item: "gochugaru",
          display: "1 tbsp gochugaru"
        },
        {
          item: "butternutSquash",
          display: "1/2 butternut squash"
        },
        {
          item: "vegetableOil",
          display: "Vegetable oil for frying"
        },
        {
          item: "onion",
          display: "1/2 onion"
        },
        {
          item: "garlicClove",
          display: "1 garlic clove, minced"
        },
        {
          item: "lemon",
          display: "1/2 tbsp lemon juice"
        },
        {
          item: "chicken",
          display: "1 cup chicken stock"
        }
      ]
    }
  ],
  steps: [
    "Slice the chicken breast into thin strips, then cut strips to 2-inch lengths. In a bowl, combine the salt, turmeric, cumin, coriander, and gochugaru.",
    "Heat 1 tbsp butter in a stainless steel skillet over high heat. Add the chicken in a single layer. If the chicken won't all fit in a single layer, go ahead and add it all. In that case, when it's time to flip the chicken as described below, start stirring it occasionally instead until it's all cooked and the pan is browned.",
    "Sprinkle half of the spice mix over the chicken. Reserve the other half. Cook until the chicken releases from the pan, then flip pieces over and cook until the liquid evaporates and the chicken browns. The pan should get a browned residue as well.",
    "Meanwhile, peel the squash and slice into 1/4 inch thick slices. If you're using the part of the squash with seeds, once you start slicing into the seed chamber, using a spoon to scrape out seeds and discard. Then continue slicing. Fry the slices at 350 degrees Fahrenheit, flipping once, until tender and browned in spots.",
    "Once the chicken is cooked, remove the chicken from the pan and cover to keep warm. Place 1 tbsp butter in the pan and turn down to medium high heat. Dice the onion, and peel and mince the garlic. Add onion and garlic to the pan and cook until the onion is tender.",
    "Add lemon juice, chicken stock, and the rest of the spice mix to the pan, and stir to deglaze. Simmer for 5 minutes until it's a little thicker. Add 2 tbsp butter, then cook and stir until combined. Remove from heat.",
    "To serve, layer fried squash, then chicken, then drizzle sauce on top."
  ]
}
